import { ITableCol } from "@data/interfaces/itable.interface";
import { ROLE_STATUS_COLOR_ENUM, ROLE_STATUS_ENUM } from "@modules/private/admin/data/enum/role.enum";

export const ROLE_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Activo' },
  { value: 'DELETED', label: 'Eliminado' }
]

export const ROLE_COLUMNS: ITableCol[] = [
  { type: 'text', field: 'name', header: 'Nombre del role', showFilter: false },
  // { type: 'text', field: 'modules', header: 'Permisos', showFilter: true },
  { type: 'text', field: 'description', header: 'Descripción', showFilter: true },
  { type: 'text', field: 'createdAt', header: 'Fecha de creación', showFilter: true, dataType: 'date' },
  { type: 'enum', field: 'status', header: 'Estatus', showFilter: true, dataType: 'enum', enum: ROLE_STATUS_ENUM, enumColor: ROLE_STATUS_COLOR_ENUM, options: ROLE_STATUS_OPTIONS },
]

